import AttendeeCtrl from './AttendeeCtrl';

export default AttendeeCtrl;
